import React, { useState } from 'react';
import { Button, Card, Col, Divider, Form, Modal, Row, Select, Space, Switch, Table, Tag } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import CustomContent from '../../../components/Content/CustomContent';
import { deleteData, fetchData, saveData } from '../../../nextgen/service/dataServices';
import { useTranslation } from 'react-i18next';
const { Option } = Select;

const Languages = () => {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState([]);
  const [isoLanguages, setIsoLanguages] = useState([]);
  const [modalOperationType, setModalOperationType] = useState('Add');
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [form] = Form.useForm();



  const response = fetchData('/api/languages', response => setTableData(response));
  fetchData('/api/languages/iso', response => setIsoLanguages(response));
  const saveMutation = saveData('/api/languages', 'POST');
  const updateMutation = saveData('/api/languages', 'PUT');
  const deleteMutation = deleteData('/api/languages');

  const columns = [
    {
      title: t('common.title'),
      dataIndex: ['isoLanguage', 'title'],
      key: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: t('appCms.languages.code'),
      dataIndex: ['isoLanguage', 'code'],
      key: 'code',
    },
    {
      title: t('appCms.languages.details'),
      key: 'details',
      render: (text, record) => (
        <Space>
          {record.defaultInMobileApp && (
            <Tag color="geekblue">
              {t('appCms.languages.default')}
            </Tag>
          )}
          {record.usedInMobileApp && (
            <Tag color="green">
              {t('appCms.languages.app')}
            </Tag>
          )}
          {record.directionRightToLeft && (
            <Tag color="geekblue">
              {t('appCms.languages.rtl')}
            </Tag>
          )}
        </Space>
      ),
    },
    {
      title: t('common.update'),
      key: 'update',
      render: (val, record) => {
        return (<Button onClick={() => onUpdate(record)} shape="circle" icon={<EditOutlined />} />);
      },
    },
    {
      title: t('common.delete'),
      key: 'delete',
      render: (val, record) => {
        return (<Button onClick={() => onDelete(record.id)} shape="circle" icon={<DeleteOutlined />} />);
      },
    },
  ];

  const onFinish = (values) => {
    if (selectedLanguage) {
      updateMutation.mutate({ dataToSend: values, id: selectedLanguage.id })
    } else {
      saveMutation.mutate({ dataToSend: values })
    }
    form.resetFields();
    setSelectedLanguage(null);
    setModalVisible(false);
  }

  const onChange = (param) => {
    form.setFieldsValue(param);
  };

  const onUpdate = (value) => {
    setModalOperationType('Update');
    setSelectedLanguage(value);
    form.setFieldsValue({
      isoLanguageId: value.isoLanguage.id,
      usedInMobileApp: value.usedInMobileApp,
      defaultInMobileApp: value.defaultInMobileApp,
      directionRightToLeft: value.directionRightToLeft
    })
    setModalVisible(true);
  };

  const onDelete = (id) => {
    deleteMutation.mutate({ idList: id })
  };

  const onAddNew = () => {
    setModalOperationType('Add');
    setModalVisible(true);
    form.resetFields();
  };

  return (
    (<CustomContent>
      <Row gutter={16} align="middle" justify="center">
        <Col span={18}>
          <Card
            title={t('appCms.languages.languages')}
            extra={
              (<Button onClick={onAddNew} icon={<PlusOutlined />}>
                {t('appCms.languages.addNew')}
              </Button>)}
          >
            <Table
              loading={response.isFetching}
              dataSource={tableData}
              columns={columns}
              rowKey={record => record.id}
              pagination={false}
              expandable={{ childrenColumnName: 'not-expandable' }}
            />
          </Card>
        </Col>
      </Row>
      <Modal
        title={`${modalOperationType} ${t('appCms.languages.language')}`}
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          form.resetFields();
        }}
        closable={false}
        destroyOnHidden={true}
        footer={false}
        centered
      >
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          autoComplete="off"
        >
          <Row justify="center" align="middle">
            <Col span={18}>

              <Form.Item label={t('appCms.languages.language')} name="isoLanguageId">
                <Select
                  showSearch
                  filterOption
                  optionFilterProp="children"
                  placeholder={t('appCms.languages.selectLanguage')}
                  allowClear
                >
                  {
                    isoLanguages && isoLanguages.map(option => (
                      <Option value={option.id} key={option.id}>{option.title}</Option>
                    ))
                  }
                </Select>
              </Form.Item>

              <Form.Item
                label={t('appCms.languages.usedInMobileApp')}
                name='usedInMobileApp'
                valuePropName="checked"
                initialValue={false}
              >
                <Switch onChange={(val) => onChange({ 'usedInMobileApp': val })} />
              </Form.Item>

              <Form.Item
                label={t('appCms.languages.defaultInMobileApp')}
                name='defaultInMobileApp'
                valuePropName="checked"
                initialValue={false}
              >
                <Switch onChange={(val) => onChange({ 'defaultInMobileApp': val })} />
              </Form.Item>

              <Form.Item
                label={t('appCms.languages.directionRightToLeft')}
                name='directionRightToLeft'
                valuePropName="checked"
                initialValue={false}
              >
                <Switch onChange={(val) => onChange({ 'directionRightToLeft': val })} />
              </Form.Item>

              <Divider />
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Button type="primary" htmlType="submit">
                  {t('appCms.languages.submit')}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </CustomContent>)
  );
};

export default Languages;
